import * as React from "react";
import mixpanelService from "./mixpanelService";
import mixpanelEvents, { getScreenName } from "../../config/mixpanelEvents";

function humanize(name: string): string {
  return name
    .replace(/[_-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (c) => c.toUpperCase())
    .replace(/\s+/g, " ")
    .trim();
}

export function trackClientError(
  errorText?: string | null,
  fieldName?: string,
  fieldLabel?: string
) {
  try {
    if (!errorText) return;

    const field_name = fieldName || "";
    const label = (fieldLabel || "").replace(/\s+/g, " ").trim();

    mixpanelService({
      event: mixpanelEvents.ERROR_TRIGGERED,
      screen_name: getScreenName(window.location.pathname),
      error_type: "client",
      field_name,
      text: label || (field_name ? humanize(field_name) : ""),
      error_message: errorText,
      error_object: errorText,
    });
  } catch (e) {
    console.error("mixpanel client error_triggered failed", e);
  }
}

export function useClientErrorTracking(
  errorText?: string | null,
  fieldName?: string,
  fieldLabel?: string
) {
  React.useEffect(() => {
    trackClientError(errorText, fieldName, fieldLabel);
  }, [errorText, fieldName, fieldLabel]);
}
